/**
 * DEBUG调试模式
 *@author caijing
 *@date 2022/4/7 15:35
 */
export const Debug = false;
